module.exports = __webpack_public_path__ + "media/images/menu/hydrus-fedb490b78eef68ad36c165c04b2a87c.jpg";